// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarGroup_container__3P7qq","avatarContainer":"AvatarGroup_avatarContainer__2ETQ6"};